import { useState, useRef, memo } from 'react';
import type { VariableSizeList } from 'react-window';

import { Loading } from '../Loading';

import { Controls } from './Controls';
import { Viewer } from './Viewer';
import { usePdf } from './hooks/usePdf.hook';
import type { ScrollingStatus } from './types/scrolling-status.type';

interface Props {
  readonly url: string;
  readonly showControls?: boolean;
  readonly withCredentials?: boolean;
}

// MHO : from https://codesandbox.io/s/pdf-viewer-w7wpu
const PdfViewerCmp = ({
  showControls = false,
  url,
  withCredentials = true,
}: Readonly<Props>) => {
  const [scale, setScale] = useState(1);
  const [scrollingStatus, setScrollingStatus] = useState<ScrollingStatus>({
    pageNumber: 1,
    isControlled: false,
  });
  const pageListRef = useRef<VariableSizeList<unknown> | null>(null);

  const { getPage, isLoading, totalPageCount } = usePdf({
    url,
    withCredentials,
  });

  return isLoading ? (
    <Loading />
  ) : (
    <>
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */}
      {!!showControls && (
        <Controls
          pageListRef={pageListRef}
          scrollingStatus={scrollingStatus}
          setScale={setScale}
          setScrollingStatus={setScrollingStatus}
          totalPageCount={totalPageCount}
        />
      )}
      <Viewer
        getPage={getPage}
        pageListRef={pageListRef}
        scale={scale}
        setScrollingStatus={setScrollingStatus}
        totalPageCount={totalPageCount}
      />
    </>
  );
};

export const PdfViewer = memo(PdfViewerCmp);

PdfViewer.displayName = 'PdfViewer';
